import { noop } from '@dazn/peng-html5-tools-utils';
/**
 * Returns two functions which can be used to make abortable Hyper requests, and abort them later.
 */
var createRequestAborter = function () {
    var requests = [];
    var removeInactiveRequest = function (request) {
        requests.splice(requests.indexOf(request), 1);
    };
    return {
        makeAbortableRequest: function (request) {
            requests.push(request);
            request.done
                .then(function () {
                requests.splice(requests.indexOf(request), 1);
            })
                .catch(noop);
            return request.done;
        },
        abortInflightRequests: function () {
            requests.forEach(function (request) {
                request.abort();
                removeInactiveRequest(request);
            });
        },
    };
};
export { createRequestAborter };
//# sourceMappingURL=createRequestAborter.js.map